import PurpleButton from '../../components/purple-button';
import CountUp from '../../components/countup';
import {useEffect, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {toggleActionModal} from '../../../reducers/modals-action/actions';
import {closePromotionModal, clickPromotionModal} from '../../../utils/promotions';
import Selector from '../../../selectors/pages/freecash/promocode';
import {activatePromocode} from '../../../reducers/freecash/actions';

import confetti from 'canvas-confetti';

const independenceDayFirework = () => {
    const colors = [
        "#B31942", // red
        "#FFFFFF",
        "#0A3161"  // blue
    ];

    // Большой центральный взрыв
    confetti({
        particleCount: 180,
        spread: 170,
        startVelocity: 45,
        origin: {
            x: 0.5,
            y: 1
        },
        colors,
        scalar: 1.1,
        zIndex: 99999
    });

    // Через 250мс запускаем шоу
    setTimeout(() => {
        const duration = 2500;
        const end = Date.now() + duration;

        (function frame() {
            // Левый салют
            confetti({
                particleCount: 4,
                angle: 60,
                spread: 70,
                startVelocity: 35,
                origin: {
                    x: 0,
                    y: 1
                },
                colors,
                zIndex: 99999
            });

            // Правый салют
            confetti({
                particleCount: 4,
                angle: 120,
                spread: 70,
                startVelocity: 35,
                origin: {
                    x: 1,
                    y: 1
                },
                colors,
                zIndex: 99999
            });

            // Дождь сверху
            confetti({
                particleCount: 3,
                angle: 90,
                spread: 35,
                startVelocity: 18,
                gravity: 0.7,
                drift: (Math.random() - 0.5) * 0.8,
                origin: {
                    x: Math.random(),
                    y: -0.05
                },
                colors,
                scalar: 0.9,
                zIndex: 99999
            });

            if (Date.now() < end) {
                requestAnimationFrame(frame);
            }
        })();
    }, 250);

    // Финальный дождь из эмодзи
    setTimeout(() => {
        confetti({
            particleCount: 35,
            spread: 120,
            startVelocity: 18,
            gravity: 0.6,
            scalar: 1.6,
            angle: 90,
            origin: {
                x: 0.5,
                y: -0.05
            },
            shapes: ["emoji"],
            shapeOptions: {
                emoji: {
                    value: [
                        "🇺🇸",
                        "⭐",
                        "🎆",
                        "🎇"
                    ]
                }
            },
            zIndex: 99999
        });
    }, 700);
};

export default ({index}) => {
    const dispatch = useDispatch(),
          {button} = useSelector(Selector);

    // Refs
    const overlay = useRef(),
          modal = useRef();

    const closeAction = (trigger, callback) => {
        if(modal.current) {
            modal.current.classList.remove('animate__slideInUp');
            modal.current.classList.add('animate__slideOutDown');
        }

        if(overlay.current) {
            overlay.current.classList.remove('animate__fadeIn');
            overlay.current.classList.add('animate__fadeOut');
        }

        setTimeout(() => {
            dispatch(toggleActionModal('250-years'));
            if(trigger === 'close')
                closePromotionModal('250-years');
            else
                clickPromotionModal('250-years', callback);
        }, 500);
    }

    useEffect(() => {
        independenceDayFirework();
    }, []);
    
    return (
        <div className="action-modal-fix independence_day">
            <div style={{zIndex: 400 + index}} className="action-modal-overlay animate__animated animate__fadeIn animate__faster" ref={overlay}></div>
            <div style={{zIndex: 400 + index}} className="action-modal-container">
                <div className="action-modal animate__animated animate__slideInUp animate__faster" ref={modal}>
                    <div className="action-modal-body-container">
                        <div className="action-modal-body-top">
                            <div className="close" onClick={e => closeAction('close')}>
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M6 18L18 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                    <path d="M18 18L6 6" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                </svg>
                            </div>
                        </div>
                        <div className="action-modal-body">
                            <div className="independence_day-title">
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    width="800"
                                    height="800"
                                    viewBox="0 0 36 36"
                                    aria-hidden="true"
                                    role="img"
                                    className="iconify iconify--twemoji"
                                    preserveAspectRatio="xMidYMid meet"
                                >
                                    <path
                                        fill="#B22334"
                                        d="M35.445 7C34.752 5.809 33.477 5 32 5H18v2h17.445zM0 25h36v2H0zm18-8h18v2H18zm0-4h18v2H18zM0 21h36v2H0zm4 10h28c1.477 0 2.752-.809 3.445-2H.555c.693 1.191 1.968 2 3.445 2zM18 9h18v2H18z"
                                    />
                                    <path
                                        fill="#EEE"
                                        d="M.068 27.679c.017.093.036.186.059.277c.026.101.058.198.092.296c.089.259.197.509.333.743L.555 29h34.89l.002-.004a4.22 4.22 0 0 0 .332-.741a3.75 3.75 0 0 0 .152-.576c.041-.22.069-.446.069-.679H0c0 .233.028.458.068.679zM0 23h36v2H0zm0-4v2h36v-2H18zm18-4h18v2H18zm0-4h18v2H18zM0 9zm.555-2l-.003.005L.555 7zM.128 8.044c.025-.102.06-.199.092-.297a3.78 3.78 0 0 0-.092.297zM18 9h18c0-.233-.028-.459-.069-.68a3.606 3.606 0 0 0-.153-.576A4.21 4.21 0 0 0 35.445 7H18v2z"
                                    />
                                    <path
                                        fill="#3C3B6E"
                                        d="M18 5H4a4 4 0 0 0-4 4v10h18V5z"
                                    />
                                    <path
                                        fill="#FFF"
                                        d="M2.001 7.726l.618.449l-.236.725L3 8.452l.618.448l-.236-.725L4 7.726h-.764L3 7l-.235.726zm2 2l.618.449l-.236.725l.617-.448l.618.448l-.236-.725L6 9.726h-.764L5 9l-.235.726zm4 0l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L9 9l-.235.726zm4 0l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L13 9l-.235.726zm-8 4l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L5 13l-.235.726zm4 0l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L9 13l-.235.726zm4 0l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L13 13l-.235.726zm-6-6l.618.449l-.236.725L7 8.452l.618.448l-.236-.725L8 7.726h-.764L7 7l-.235.726zm4 0l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L11 7l-.235.726zm4 0l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L15 7l-.235.726zm-12 4l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L3 11l-.235.726zM6.383 12.9L7 12.452l.618.448l-.236-.725l.618-.449h-.764L7 11l-.235.726h-.764l.618.449zm3.618-1.174l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L11 11l-.235.726zm4 0l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L15 11l-.235.726zm-12 4l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L3 15l-.235.726zM6.383 16.9L7 16.452l.618.448l-.236-.725l.618-.449h-.764L7 15l-.235.726h-.764l.618.449zm3.618-1.174l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L11 15l-.235.726zm4 0l.618.449l-.236.725l.617-.448l.618.448l-.236-.725l.618-.449h-.764L15 15l-.235.726z"
                                    />
                                </svg>
                                Happy Independence Day!
                            </div>
                            <div className="independence_day-image"></div>
                            <PurpleButton active={button} onClick={e => {
                                dispatch(activatePromocode('DBE8038', () => {
                                    closeAction('click');
                                }));
                            }}>Claim Bonus</PurpleButton>
                            <div className="description">Celebrate the 4th of July with a special holiday bonus. Claim your gift and enjoy the festivities!</div>
                        </div>
                    </div>
                </div>
            </div> 
        </div>
    )
}